import axios from 'axios';
import {responseHandler} from './responseHandler';
import {CommonPayload} from '../../@types/actions';
import {apiServiceUrl} from "./skeletonSaga";

export const skeletonPost = (
    payload: CommonPayload,
    action: string,
    endpoint: string
): Promise<unknown> => {
    let data = payload;
    const token = localStorage.getItem('sessionToken');
    const headers = {"Authorization": `Bearer ${token}`};
    return axios
        .post(apiServiceUrl + endpoint + '/' + action, data, {headers: headers})
        .then(response => responseHandler(response))
        .catch(function (error) {
            throw error;
        });
};
